import _ from "lodash";

const listKey = (key) => ["feedFilterList", ...key];

export const cachedFilterList = (queryClient, key) =>
  _.get(queryClient.getQueryData(listKey(key)), "result", []) || [];

// gcTime: nothing observes these keys, so the default 5 minute gc would drop
// them and bring the panel's jump back. A failed request must not be cached:
// apiService resolves [] on a thrown error, and the lists answer errorCode != 0
// on failure, so throw and let the next open retry.
export const loadFilterList = (queryClient, key, fetcher) =>
  queryClient.fetchQuery({
    queryKey: listKey(key),
    queryFn: async () => {
      const response = await fetcher();
      if (response?.errorCode !== 0) throw new Error(`feed filter list failed: ${key.join("/")}`);
      return response;
    },
    staleTime: Infinity,
    gcTime: Infinity,
  });
